import FacebookEmbedCustom from "@components/Embeds/FacebookEmbedCustom";
import InstagramEmbedCustom from "@components/Embeds/InstagramEmbedCustom";
import LiveBlogEmbed from "@components/Embeds/LiveBlogEmbed";
import TiktokEmbedCustom from "@components/Embeds/TiktokEmbedCustom";
import XEmbedCustom from "@components/Embeds/XEmbedCustom";
import { EmbedType } from "@routes/Article/components/ArticleParagraphElements/utils/enums";
import { cn } from "@util/helpers";
import { DOMNode, domToReact, Element } from "html-react-parser";
import IframeResizer from "iframe-resizer-react";

type TransformOptions = string | boolean | void | object | Element | null;

export const createEmbed = () => {
  const transform = (node: DOMNode, type: EmbedType): TransformOptions => {
    if (node.type !== "tag") return null;

    const element = node;

    if (element.name === "div" && type === EmbedType.Embed) {
      const children = element.children as DOMNode[];
      const transformWithType = (child: DOMNode) => transform(child, type);

      return (
        <div className="mb-6">
          {domToReact(children, { replace: transformWithType })}
        </div>
      );
    }

    if (type === EmbedType.X) {
      const el = node;
      const href = el.attribs["data-href"];
      const cssClass = el.attribs["data-cssClass"];

      if (!href) return null;

      return <XEmbedCustom url={href} className={cssClass} />;
    }

    if (type === EmbedType.Instagram) {
      const el = node;
      const href = el.attribs["data-href"];
      const cssClass = el.attribs["data-cssClass"];

      if (!href) return null;

      return <InstagramEmbedCustom url={href} className={cssClass} />;
    }

    if (element.name === "iframe" && type === EmbedType.Facebook) {
      const el = node;
      const href = el.attribs.src;
      const urlParams = new URLSearchParams(href.split("?")[1]);
      const fbUri = urlParams.get("href") || "";

      return <FacebookEmbedCustom url={fbUri} />;
    }

    if (element.name === "blockquote" && type === EmbedType.Tiktok) {
      const el = node;
      const href = el.attribs.cite;

      return <TiktokEmbedCustom url={href} />;
    }

    if (element.name === "iframe" && type === EmbedType.Embed) {
      const el = node;
      const { src, id, classname, className, height = "500px" } = el.attribs;

      const extraClass = classname || className || ""; // Handle both 'classname' and 'className' attributes

      const { hostname, searchParams } = new URL(src);
      const liveblogId = searchParams.get("id");

      if (hostname.includes("liveblog.com") && liveblogId) {
        return <LiveBlogEmbed liveblogId={liveblogId} height={height} />;
      }

      return (
        <IframeResizer
          data-testid={id}
          src={src}
          className={cn("w-full", extraClass)}
          style={{ height }}
        />
      );
    }

    return null;
  };

  return transform;
};
